import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faThumbsUp } from '@fortawesome/pro-duotone-svg-icons/faThumbsUp';
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons/faTriangleExclamation';
import { Button } from '@rocketlane/ui';
import { useForm } from 'antd/lib/form/Form';
import React, { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { EmptyState, EmptyStateContainer, EmptyStateIcon } from 'components/atoms/empty-state';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { Loading } from 'components/atoms/loading';
import { useAddUsersFromShareUrl } from 'hooks/customer-portal/use-customer-portal-hooks';
import { useQueryParams } from 'hooks/use-query-params';
import { ProductiveHeading03, ProductiveHeading05 } from 'components/atoms/typography';
import { useAccountMetaQuery } from 'queries';
import { isValidEmail } from 'utils/is-valid-email';
const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
  padding: var(--layout-06);
  flex-direction: column;
`;
const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;

  .ant-avatar {
    height: 68px;
    width: 68px;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  margin-left: var(--spacing-06);
`;
const WelcomeText = styled(ProductiveHeading05)``;
const LoginText = styled(ProductiveHeading03)`
  font-weight: normal;
`;
const FormWrapper = styled.div`
  margin-top: var(--layout-05);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  ${Input} {
    width: 500px;
  }

  .ant-row.ant-form-item {
    padding-bottom: 0;
  }
`;
export const EmailInputForm = ({ isSubmitting, onSubmit, form })=>{
    var _getMetaQueryData_company, _getMetaQueryData_company1, _getMetaQueryData_company2;
    const { data: getMetaQueryData } = useAccountMetaQuery();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(HeaderWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        shape: "square",
                        size: "large",
                        src: getMetaQueryData === null || getMetaQueryData === void 0 ? void 0 : (_getMetaQueryData_company = getMetaQueryData.company) === null || _getMetaQueryData_company === void 0 ? void 0 : _getMetaQueryData_company.companyLogoUrl,
                        name: getMetaQueryData === null || getMetaQueryData === void 0 ? void 0 : (_getMetaQueryData_company1 = getMetaQueryData.company) === null || _getMetaQueryData_company1 === void 0 ? void 0 : _getMetaQueryData_company1.companyName
                    }),
                    /*#__PURE__*/ _jsxs(TextWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(WelcomeText, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "cp.share_page.welcome"
                                })
                            }),
                            /*#__PURE__*/ _jsx(LoginText, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "cp.share_page.log_in",
                                    values: {
                                        companyName: getMetaQueryData === null || getMetaQueryData === void 0 ? void 0 : (_getMetaQueryData_company2 = getMetaQueryData.company) === null || _getMetaQueryData_company2 === void 0 ? void 0 : _getMetaQueryData_company2.companyName
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FormWrapper, {
                children: /*#__PURE__*/ _jsxs(Form, {
                    layout: "vertical",
                    form: form,
                    onFinish: onSubmit,
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: "email",
                            label: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "cp.share_page.email_label"
                            }),
                            rules: [
                                {
                                    required: true,
                                    type: 'email'
                                }
                            ],
                            children: /*#__PURE__*/ _jsx(Input, {})
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            loading: isSubmitting,
                            variant: "primary",
                            type: "submit",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "login"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const SuccessMessage = ()=>{
    var _getMetaQueryData_company;
    const { data: getMetaQueryData } = useAccountMetaQuery();
    return /*#__PURE__*/ _jsx(EmptyStateContainer, {
        children: /*#__PURE__*/ _jsx(EmptyState, {
            image: /*#__PURE__*/ _jsx(EmptyStateIcon, {
                icon: faThumbsUp
            }),
            title: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "cp.share_page.login.success.title"
            }),
            message: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "cp.share_page.login.success.message",
                values: {
                    companyName: getMetaQueryData === null || getMetaQueryData === void 0 ? void 0 : (_getMetaQueryData_company = getMetaQueryData.company) === null || _getMetaQueryData_company === void 0 ? void 0 : _getMetaQueryData_company.companyName
                }
            })
        })
    });
};
const FailureMessage = ()=>{
    var _getMetaQueryData_company;
    const { data: getMetaQueryData } = useAccountMetaQuery();
    return /*#__PURE__*/ _jsx(EmptyStateContainer, {
        children: /*#__PURE__*/ _jsx(EmptyState, {
            image: /*#__PURE__*/ _jsx(EmptyStateIcon, {
                icon: faTriangleExclamation
            }),
            title: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "cp.share_page.login.error.title"
            }),
            message: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "cp.share_page.login.error.message",
                values: {
                    companyName: getMetaQueryData === null || getMetaQueryData === void 0 ? void 0 : (_getMetaQueryData_company = getMetaQueryData.company) === null || _getMetaQueryData_company === void 0 ? void 0 : _getMetaQueryData_company.companyName
                }
            })
        })
    });
};
const Content = ({ response, form, isSubmitting, onSubmit })=>{
    if (!response) {
        return /*#__PURE__*/ _jsx(EmailInputForm, {
            form: form,
            onSubmit: onSubmit,
            isSubmitting: isSubmitting
        });
    }
    if (response === null || response === void 0 ? void 0 : response.success) {
        return /*#__PURE__*/ _jsx(SuccessMessage, {});
    }
    return /*#__PURE__*/ _jsx(FailureMessage, {});
};
export const CpShareLinkPage = ()=>{
    const { data: getMetaQueryData } = useAccountMetaQuery();
    const qp = useQueryParams();
    const token = useMemo(()=>qp.get('token'), [
        qp
    ]);
    const { mutateAsync: addUsersFromShareUrl, isLoading: isSubmitting } = useAddUsersFromShareUrl();
    const [form] = useForm();
    const [response, setResponse] = useState(null);
    const onSubmit = useCallback(()=>{
        form.validateFields();
        const values = form.getFieldsValue();
        const emailId = values === null || values === void 0 ? void 0 : values.email;
        if (emailId) {
            if (isValidEmail(emailId) && token) {
                addUsersFromShareUrl({
                    shareToken: token,
                    user: {
                        emailId
                    }
                }).then((res)=>{
                    setResponse(res);
                });
            }
        } else {
            form.validateFields();
        }
    }, [
        addUsersFromShareUrl,
        form,
        token
    ]);
    return /*#__PURE__*/ _jsx(Page, {
        children: !getMetaQueryData ? /*#__PURE__*/ _jsx(LoadingWrapper, {
            children: /*#__PURE__*/ _jsx(Loading, {
                size: "large"
            })
        }) : /*#__PURE__*/ _jsx(Content, {
            form: form,
            onSubmit: onSubmit,
            isSubmitting: isSubmitting,
            response: response
        })
    });
};
